<template>
  <div>
    <div v-if="loading" style="padding:20px">
      <div class="ui active centered inline large loader"></div>
    </div>
    <div v-else class="ui grid" style="padding:20px">
      <div class="row">
        <div class="six wide column">
          <div class="ui header">Configuration</div>
        </div>
      </div>
      <div class="row">
        <div class="eight wide column">
          <div class="ui form">
            <div class="field">
              <div class="ui checkbox labelCursorFix">
                <input type="checkbox" data-lpignore="true" v-model="suppressChildAsinRetiries" id="lsCheckbox18425">
                <label for="lsCheckbox18425">Do not alert of child ASIN suspension</label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="six wide column">
          <button v-bind:class="dirty ? 'ui primary button' : 'ui disabled primary button'" v-on:click="save()">Save</button>
          <button class="ui basic button" @click="close()">Close </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      loading: true,
      suppressChildAsinRetiries: false,
      suppressChildAsinRetiriesOrig: false,
      dirty: false,
    }
  },
  methods: {
    load: function () {
      this.$http.get('/api/sentinel/watchdogtype/settings/listingSuspended').then((response) => {
        this.loading = false
        this.suppressChildAsinRetiries = !response.body.showChildAsinRetiries
        this.suppressChildAsinRetiriesOrig = this.suppressChildAsinRetiries
      }, (response) => {
        this.loading = false
      })
    },
    close: function () {
      this.$parent.showConfiguration = false
    },
    save: function () {
      this.$http.put('/api/sentinel/watchdogtype/settings/listingSuspended', {
        showChildAsinRetiries: !this.suppressChildAsinRetiries,
      }).then((response) => {
        this.suppressChildAsinRetiriesOrig = this.suppressChildAsinRetiries
        this.updateDirty()
      }, (response) => {
        this.loading = false
      })
    },
    updateDirty: function () {
      this.dirty = this.suppressChildAsinRetiries !== this.suppressChildAsinRetiriesOrig
    }
  },
  created: function () {
    this.load()
  },
  watch: {
    suppressChildAsinRetiries: function () {
      this.updateDirty()
    },
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// ListingSuspendedConfig.vue?532cde62